var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Family } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.families = [];
        this.loaded = false;
        this.set = function (families) {
            _this.families = families.map(function (family) { return new Family(family); });
            _this.loaded = true;
            return families;
        };
    }
    default_1.prototype.read = function (id) {
        if (id)
            return api.get('family/' + id).then(function (family) { return new Family(family); });
        return api.get('family').then(this.set);
    };
    default_1.prototype.create = function (family) {
        return api.post('family', family);
    };
    default_1.prototype.update = function (id, family) {
        return api.put('family/' + id, family);
    };
    default_1.prototype.delete = function (id) {
        return api.delete('family/' + id);
    };
    __decorate([
        observable
    ], default_1.prototype, "families", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Families/Store.ts
// module id = 681
// module chunks = 0